import Config from "app/lib/Config";
import { last7Days } from "utils/DateArrays";
import { now } from "utils/DateUtils";

export const renderData = (data, goal, DAYS) => {
    let labels = last7Days();
    return {
        labels,
        datasets: [
            {
                data: data,
                fill: true,
                backgroundColor: 'rgba(57, 118, 238, 0.4)',
                borderColor: '#3976ee',
                yAxisID: 'y',
                pointRadius: 0,
                borderWidth: 1,
                datalabels: {
                    display: false
                }
            }
        ]
    }
}

export const renderOptions = (max, min, selectedMetric) => {
    const buffer = 0.14;

    return {
        responsive: true,
        maintainAspectRatio: false,
        showTooltips: false,
        layout: {
            padding: 5
        },
        hover: {
            mode: null
        },
        interaction: {
            mode: 'index',
            intersect: false
        },
        // animation: {
        //     duration: Config.ANIMATE_GRAPH_DURATION
        // },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: 'rgba(255,255,255,1)',
                titleColor: '#142643',
                bodyColor: '#142643',
                footerColor: '#142643',
                intersect: false,
                displayColors: false,
                callbacks: {
                    title: function(item, _data) {
                        if (item.length) {
                            let d = now();
                            let nums = item[0].label.split('-');
                            let [year, month, date] = nums.map(n => parseInt(n));
                            d.set({ year, month: month - 1, date });
                            return d.format('MMMM Do');
                        }
                    },
                    label: function(item, _data) {
                        return `${selectedMetric}: ${parseFloat(item.formattedValue).toFixed(2)}`
                    }
                }
            }
        },
        elements: {
            line: {
                cubicInterpolationMode: 'monotone'
            }
        },
        scales: {
            y: {
                display: false,
                min: min,
                max: max
            },
            x: {
                display: false,
            }
        },
    }
}